import { FC } from 'react';
import { Box } from '../BoxNew'
import { Icon } from '../Icon'
import { Loader } from '../Loader'
import { Text } from '../Text'

interface EmptyViewProps {
  onRetry: () => void
  isLoading: boolean
  error?: any
  loadingMessage?: string
  emptyMessage?: string
  testID?: string
  loaderComponent?: any
  hide?: boolean
}
export const EmptyView: FC<EmptyViewProps> = ({
  onRetry,
  isLoading,
  error,
  loadingMessage = '',
  emptyMessage = '',
  testID = 'EmptyViewBox',
  hide = false,
  loaderComponent = <Loader type="small" color="BRAND_PRIMARY_ACTION" />,
}: EmptyViewProps) => {
  if (hide) {
    return null
  }
  const [errors] = error?.networkError?.data?.errors ?? []
  const message = error ? errors?.details ?? 'Something went wrong!' : isLoading ? loadingMessage : emptyMessage
  return (
    <Box
      onPress={error ? onRetry : undefined}
      justifyContent="center"
      alignItems="center"
      testID={testID}
      underlayColor="GRAY_BORDER">
      {isLoading && loaderComponent}
      {message && (
        <Text fontSize={14} fontWeight="normal" color="BLACK" fontFamily='JioType-Medium'>
          {message}
        </Text>
      )}
      {!!error && (
        <Box justifyContent="center" alignItems="center">
          <Icon id="ICON_REFRESH" size="FONT_SIZE_LARGE" />
          <Text fontSize={14} fontWeight="normal" color="BRAND_PRIMARY_ACTION" fontFamily='JioType-Medium'>
            Retry
          </Text>
        </Box>
      )}
    </Box>
  )
}
